import { makeStyles } from '@fluentui/react-components';
import { customTokens } from 'src/utils/theme';

export const useRewardsSectionStyles = makeStyles({
  rewardsSection: {
    width: '100%',
  },
  cardsContainer: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: customTokens.spacingVerticalL,
  },
  invalidProgramTypeMessage: {
    fontSize: customTokens.fontSizeBase300,
    fontWeight: customTokens.fontWeightRegular,
    lineHeight: customTokens.lineHeightBase300,
    textAlign: 'center',
  },
});
